import {Duration} from "luxon";

const calculateTime = (time: number, hyper: number, skill: number) => {
    let modifiedTime = Math.round((time/60) * (1/ ((hyper??1) * (1 +(skill*0.05)))));
    let d = Duration.fromObject({minutes: modifiedTime ?? 0});
    d = d.rescale();
    return d;
}

const calculateTimeSplit = (hyperBase: number, sublightBase: number, hyper: number, sublight: number, skill: number) => {
    const skillMod = (1 + (skill * 0.05));
    const hyperSpeed = hyper ?? 1;
    const sublightSpeed = sublight ?? 1;

    const hyperSeconds = ((hyperBase) * (1 / (hyperSpeed * skillMod)));
    const subSeconds = ((sublightBase) * (1/((sublightSpeed/10) * skillMod)));
    const minutes = Math.round((hyperSeconds + subSeconds)/60);
    // const seconds = Math.round(((hyperSeconds + subSeconds)));
    let d = Duration.fromObject({minutes});
    d = d.rescale();
    return d;
}

const formatDurationShort = (duration: Duration) => {
    const normalized = duration.rescale();
    const values = normalized.shiftTo('days', 'hours', 'minutes');
    const days = Math.floor(values.days || 0);
    const hours = Math.floor(values.hours || 0);
    const minutes = Math.floor(values.minutes || 0);

    const parts: string[] = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0 || days > 0) parts.push(`${hours}h`);
    parts.push(`${minutes}m`);
    return parts.join(' ');
}

export {calculateTime, calculateTimeSplit, formatDurationShort};
